import { CollectionItemsPrinter } from "../../Components/Utils/CollectionItemsPrinter";
import { DangerButton } from "../../Components/Utils/DangerButton";
import { PrimaryButton } from "../../Components/Utils/PrimaryButton";
import { BlogContentProvider } from "../../Services/Content/BlogContentProvider";
import { ArticleEditContent } from "./ArticleEditContent";
import { ArticleEditTitle } from "./ArticleEditTitle";
import { Heading } from "../../Components/Heading";
import { Notification } from "../../Components/Notification";
import { Page } from "../Product/Page";


export class BlogEditPage extends Page
{
    constructor(private _blog: BlogContentProvider)
    {
        super("Edycja bloga", "admin-page");

        this.Content(async (body) =>
        {
            await this._blog.Load();

            const blog = this._blog.Blog;

            body.Append(
                new Heading("Kolejność artykułów", 5).Class("section-title"),
                new CollectionItemsPrinter(blog.Articles,
                    article => [new ArticleEditTitle(article)],
                    article => [new ArticleEditContent(article)]),

                new PrimaryButton("➕ Dodaj artykuł").OnClick(() => window.location.hash = "blog/add"),

                new DangerButton("💾 Zapisz zmiany")
                    .OnClick(async () =>
                    {
                        const result = await this._blog.SaveChanges();

                        new Notification(result.IsSuccess ? "Zmiany zapisane!" : "❌ Problem z zapisaniem zmian");
                        
                        window.location.hash = "/";
                    }),

                new PrimaryButton("Wykonaj backup").OnClick(async () =>
                {
                    const re =  await this._blog.Backup();

                    new Notification(re.IsSuccess ? "✅ Backup wykonany!" : "❌ Problem z wykonaniem backupu", re.ErrorMessage);
                }),
            );
        });
    }
}
